/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { ApiStatus } from '@ibm-watson/shared/ts';
import { RootState } from '@ibm-watson/shared/ts/state';
import { selectAllIntegrations, selectDraftIntegration } from '../selectors';

export const getSelectedChannelType = (state: RootState) =>
  state.integrations?.draftIntegration?.channel_type;

export const getShowOverlay = (state: RootState) =>
  state.integrations?.draftIntegration?.show_overlay;

export const selectIsIntegrationResetNeeded = (state: RootState): boolean =>
  state.integrations?.draftIntegration?.reset_integration_form;

export const getClassicIntegrationsState = (state: RootState) => {
  return {
    fetching:
      state.integrations?.listIntegrations?.status === ApiStatus.LOADING,
    list: selectAllIntegrations(state),
    currentIntegration: selectDraftIntegration(state),
    channelType: getSelectedChannelType(state),
    showOverlay: getShowOverlay(state),
    describeFetching:
      state.integrations?.describeIntegration?.status === ApiStatus.LOADING,
    serviceDesk: state.integrations?.legacy_service_desk
  };
};
